/* Error service
 *
 * This service can be used to set and retrieve errors and track the presence of errors.
 */
SUGApp.service('errorService', ['SUGUtilities', function (SUGUtilities) {
    var service = {
        getService: function(){
            var service = {
                init: function () {
                    // clear / reinit the errors
                    service.errors = {};
                    service.hasErrors = false;
                },
                errors: {},
                hasErrors: false,
                getErrors: function (key) {
                    if (key) {
                        // get the error(s) for a specific key (can be an array or a string)
                        if (SUGUtilities.isArray(service.errors[key]) || !SUGUtilities.isStringNullOrEmpty(service.errors[key])) {
                            return service.errors[key];
                        } else {
                            return false;
                        }
                    } else {
                        // get all the errors
                        if (SUGUtilities.isEmptyObject(service.errors)) {
                            return false;
                        } else {
                            var arrErrors = [];
                            for (var field in service.errors) {
                                if (service.errors.hasOwnProperty(field)) {
                                    arrErrors = arrErrors.concat(service.errors[field]);
                                }
                            }
                            return arrErrors;
                        }
                    }
                },
                setError: function (key, value) {
                    service.errors[key] = value;
                    service.hasErrors = true;
                },
                clearErrors: function (key) {
                    if (typeof key === 'undefined') {
                        service.errors = {};
                        service.hasErrors = false;
                    } else {
                        if (typeof service.errors[key] !== 'undefined') {
                            delete service.errors[key];
                        }
                        if (jQuery.isEmptyObject(service.errors)) {
                            service.hasErrors = false;
                        } else {
                            service.hasErrors = true;
                        }
                    }
                }
            };
            return service;
        }
    };

    var coreService = service.getService();
    coreService.newInstance = service.getService;
    
    return coreService;

}]);